module.exports = __webpack_public_path__ + "img/9788954431064.106a8787.jpg";